<template>
    <div class="builds-list">
        <template v-if="computedBuilds.length">
            <a
                v-for="build in computedBuilds"
                :key="build.id"
                :class="build.classes"
                :href="build.link"
                target="_blank"
                download
                v-text="build.label"
            />
        </template>
        <template v-else>
            <p v-t="'booksBuilds.list.noDataText'" class="builds-list__nodata" />
        </template>
    </div>
</template>
<script>
import { makeid } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'BuildsList',
    props: {
        builds: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        computedBuilds() {
            return this.builds.map(
                ({ name, provider, build_type, meta_info, document, is_actual = false }) => {
                    const id = makeid();
                    const { label: typedLabel = name } = build_type || {};
                    const mixedLabel = `${provider} ${build_type}`;
                    const label = typedLabel || mixedLabel;
                    const link = `${build_type === 'meta_info' ? meta_info : document}`;
                    const classes = [
                        'builds-list__item',
                        { 'builds-list__item--actual': is_actual }
                    ];

                    return { id, label, link, classes };
                }
            );
        }
    }
};
</script>

<style lang="scss" src="./BuildsList.scss"></style>
